<template>
    <v-container fluid>
        <v-card>
            <v-toolbar
                dark
                color="secondary"
                dense
                style="padding:0px;margin:0xp;"
            >
                <v-spacer />
                <v-toolbar-title class="white--text"
                    >Shift Assignments</v-toolbar-title
                >
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-container fluid>
                    <v-row class="mx-2" style="padding:0px;margin:0xp;">
                        <v-combobox
                            v-model="header"
                            :items="shift_headers"
                            :item-text="'ShiftDate'"
                            :item-value="'ShiftId'"
                            label="Select Shift"
                            :aria-activedescendant="'list-item-210-32'"
                            @change="getShifts()"
                        >
                        </v-combobox>
                        <v-combobox
                            v-model="clone_header"
                            :items="shift_headers"
                            :item-text="'ShiftDate'"
                            :item-value="'ShiftId'"
                            label="Select Shift to Clone"
                            auto-select-first
                            class="ml-2"
                            hint="Requires a shift selected."
                            append-icon="mdi-content-copy"
                            color="primary"
                            @click:append="cloneShift(1)"
                            persistent-hint
                        ></v-combobox>

                        <v-textarea
                            class="mx-2"
                            label="Comments"
                            rows="3"
                            row-height="20"
                            append-icon="mdi-content-save"
                            v-model="comment['ShiftComments']"
                            @click:append="validate(1)"
                        ></v-textarea>
                    </v-row>
                </v-container>
            </v-form>
            <v-data-table
                :headers="headers"
                :items="shifts"
                item-key="ShiftDetail"
                :search="search"
                dense
                :loading="dataLoading"
                loading-text="Loading..."
                hide-default-footer
                disable-pagination
                style="padding:0px;margin:0xp;"
            >
                <template v-slot:top>
                    <v-container fluid>
                        <v-row style="padding-top:0px;margin-top:0xp;">
                            <v-col cols="6">
                                <v-text-field
                                    v-model="search"
                                    label="Search"
                                    append-icon="mdi-magnify"
                                    dense
                                >
                                </v-text-field>
                            </v-col>

                            <v-btn
                                class="mr-5"
                                fab
                                color="secondary"
                                icon
                                @click="openMdAssingment"
                            >
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn
                                class="mr-5"
                                fab
                                color="secondary"
                                icon
                                @click="openMdTruck"
                            >
                                <v-icon>mdi-truck-alert</v-icon>
                            </v-btn>
                            <!-- <v-btn
                                class="mr-5"
                                fab
                                color="secondary"
                                icon
                                @click="showBenchDrivers"
                            >
                                <v-icon>mdi-bench-back</v-icon>
                            </v-btn>

                            <v-btn
                                class="mr-5"
                                fab
                                color="secondary"
                                icon
                                @click="withoutTrailersDlg = true;"
                            >
                                <v-icon>mdi-truck-trailer</v-icon>
                            </v-btn> -->
                            <v-col lg="2">
                                Totals:
                                <v-chip class="divs" label value>
                                    {{ shifts.length }}
                                </v-chip>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="prints"
                                class="my-auto"
                                fab
                                color="secondary"
                                icon
                                @click="validate(2)"
                            >
                                <v-icon>mdi-printer </v-icon>
                            </v-btn>
                            <v-btn
                                v-if="prints"
                                class="my-auto"
                                fab
                                color="secondary"
                                icon
                                @click="validate(3)"
                            >
                                <v-icon>mdi-microsoft-excel </v-icon>
                            </v-btn>
                        </v-row>

                        <v-divider></v-divider>
                    </v-container>
                </template>
                <template v-slot:item.Change="{ item }">
                    <v-btn icon @click="confirmChange(item)"
                        ><v-icon>mdi-swap-horizontal</v-icon></v-btn
                    >
                </template>
                <template v-slot:item.Driver="{ item }">
                    <v-combobox
                        dense
                        class="mt-2"
                        v-model="item.Driver"
                        :items="drivers"
                        :item-text="'Name'"
                        :item-value="'id'"
                        auto-select-first
                        @change="changeDriver(item)"
                    ></v-combobox>
                </template>
                <template v-slot:item.Truck="{ item }">
                    <v-combobox
                        dense
                        class="mt-2"
                        v-model="item.Truck"
                        :items="trucks"
                        :item-text="'Truck'"
                        :item-value="'TruckID'"
                        auto-select-first
                        @change="changeTruck(item)"
                        :background-color="
                            item.TruckOutService == 1
                                ? '#ffedaa'
                                : 'transparent'
                        "
                    ></v-combobox>
                </template>
                <template v-slot:item.Trailer="{ item }">
                    <v-combobox
                        dense
                        class="mt-2"
                        v-model="item.Trailer"
                        :items="trailers"
                        :item-text="'Trailer'"
                        :item-value="'id'"
                        auto-select-first
                        @change="changeTrailer(item)"
                        :background-color="
                            item.TrailerOutService == 1
                                ? '#ffedaa'
                                : 'transparent'
                        "
                    >
                    </v-combobox>
                </template>
                <template v-slot:item.Yard="{ item }">
                    <v-combobox
                        dense
                        class="mt-2"
                        v-model="item.Yard"
                        :items="yards"
                        :item-text="'Yard'"
                        :item-value="'id'"
                        auto-select-first
                        @change="changeYard(item)"
                    ></v-combobox>
                </template>
                <template v-slot:item.ReplacementUnit="{ item }">
                    <v-text-field
                        dense
                        class="mt-2"
                        v-model="item.ReplacementUnit"
                        @change="changeReplacementUnit(item)"
                    ></v-text-field>
                </template>
                <template v-slot:item.ShiftStartTime="{ item }">
                    <v-text-field
                        dense
                        class="mt-2"
                        @change="changeStartTime(item)"
                        :rules="dateRules"
                        v-mask="'####/##/## ##:##'"
                        v-model="item.ShiftStartTime"
                    ></v-text-field>
                </template>
                <template v-slot:item.DriverTrainer="{ item }">
                    <v-combobox
                        dense
                        class="mt-2"
                        v-model="item.DriverTrainer"
                        :items="drivers"
                        :item-text="'Name'"
                        :item-value="'id'"
                        auto-select-first
                        @change="changeDriverTrainer(item)"
                    ></v-combobox>
                </template>
                <template v-slot:item.TargetHours="{ item }">
                    <v-text-field
                        dense
                        class="mt-2"
                        @change="changeTargetHours(item)"
                        v-model="item.TargetHours"
                    ></v-text-field>
                </template>
                <template v-slot:item.Bench="{ item }">
                    <v-icon class="ml-3" @click="deleteItem(item, 1)"
                        >mdi-backspace
                    </v-icon>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon class="ml-3" @click="deleteItem(item, 0)"
                        >mdi-delete</v-icon
                    >
                </template>
            </v-data-table>
        </v-card>

        <bookOff :itm="book" v-if="$store.state.book.dialog"></bookOff>

        <addAssignment v-if="$store.state.assignment.dialog" :data="parms" />
        <truckDisabled
            v-if="$store.state.assignment.truckDisabled"
            :data="shifts"
            :header="header"
        ></truckDisabled>
        <bench_driver
            v-if="benchDialog"
            :benchDialog="benchDialog"
            :itm="book"
            @close="benchDialog = false"
            @closeRc="getShifts()"
        ></bench_driver>
        <benched
            v-if="drBenchDialog"
            :drBenchDialog="drBenchDialog"
            :shiftId="header.ShiftId"
            @close="drBenchDialog = false"
        ></benched>
        <withoutTrailers
            v-if="withoutTrailersDlg"
            :withoutTrailersDlg="withoutTrailersDlg"
            :withoutTrailers="withoutTrailers"
            @close="withoutTrailersDlg = false"
        ></withoutTrailers>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mask } from 'vue-the-mask';
import addAssignment from './../Modals/Dispatch/Shift Assignments/AddAssignments.vue';
import bookOff from './../Modals/Dispatch/Shift Assignments/BookOff.vue';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
import truckDisabled from './../Modals/Dispatch/Shift Assignments/DisabledTruck.vue';
import bench_driver from './../Modals/Dispatch/Shift Assignments/BenchDriver.vue';
import benched from './../Modals/Dispatch/Shift Assignments/BookOffDrivers.vue';
import withoutTrailers from './../Modals/Dispatch/Shift Assignments/WithoutTrailer.vue';
export default {
    name: 'ShiftAssignments',
    components: {
        bookOff,
        addAssignment,
        truckDisabled,
        ConfirmDialogue,
        bench_driver,
        benched,
        withoutTrailers
    },
    directives: {
        mask
    },
    data: function() {
        return {
            withoutTrailersDlg: false,
            withoutTrailers: [],
            drBenchDialog: false,
            benchDialog: false,
            scrollTo: false,
            shiftDetailByURL: '',
            index: 0,
            prints: false,
            pdfDialog: false,
            urlPdf: '',
            parms: [],
            book: [],
            header: null,
            driver: null,
            comment: [],
            clone_header: null,
            shift_headers: [],
            shifts: [],
            drivers: [],
            trucks: [],
            trailers: [],
            yards: [],
            headers: [
                { text: 'Shift #', value: 'ShiftDetail', width: '6%' },
                { text: 'Change', value: 'Change', width: '6%' },
                { text: 'Driver', value: 'Driver', width: '15%' },
                { text: 'Truck', value: 'Truck', width: '10%' },
                { text: 'Trailer', value: 'Trailer', width: '15%' },
                { text: 'Yard', value: 'Yard', width: '15%' },
                {
                    text: 'Replacement Unit',
                    value: 'ReplacementUnit',
                    sortable: false,
                    width: '5%'
                },
                { text: 'Start Time', value: 'ShiftStartTime', width: '13%' },
                {
                    text: 'Driver Trainer',
                    value: 'DriverTrainer',
                    width: '13%'
                },
                { text: 'Target Hours', value: 'TargetHours', width: '5%' },
                // { text: 'Bench', value: 'Bench', width: '5%' },

                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    width: '5%'
                }
            ],
            valid: true,
            search: '',
            dataLoading: false,
            dateRules: [
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[11] + v[12]) <= 24 &&
                        parseInt(v[11] + v[12]) >= 0) ||
                    'Hour Incorrect',
                v =>
                    (parseInt(v[14] + v[15]) <= 59 &&
                        parseInt(v[14] + v[15]) >= 0) ||
                    'Minutes Incorrect'
            ]
        };
    },
    mounted() {
        this.shiftDetailByURL = this.$route.hash.substring(1);
        console.log(this.shiftDetailByURL);
        this.loadShiftHeaders();
        this.loadDrivers();
        this.loadTrucks();
        this.loadTrailers();
        this.loadYards();
    },
    watch: {
        '$store.state.book.dialog': function() {
            if (this.$store.state.book.dialog == false) {
                this.loadShifts(this.header.ShiftId);
            } else {
                console.log('test');
            }
        },
        '$store.state.assignment.new': function() {
            if (this.$store.state.assignment.new == false) {
                this.getShifts();
            } else {
                console.log('test');
            }
        }
    },
    methods: {
        showBenchDrivers: function() {
            console.log('Driver');
            this.drBenchDialog = true;
        },
        async confirmChange(item) {
            const act = this.header.Shift == 'PM' ? 'AM' : 'PM';
            const ok = await this.$refs.confirmDialogue.show({
                title:
                    'You are about to change this driver to shift ' +
                    this.header.Date +
                    ' ' +
                    act,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.chageShift(item);
            }
        },
        chageShift: function(item) {
            var parms = {};
            if (this.header.Shift == 'PM') {
                parms.ShiftHeaderNum = this.header.ShiftId - 1;
            } else {
                parms.ShiftHeaderNum = this.header.ShiftId + 1;
            }
            axios
                .put('shift-detail/' + item.ShiftDetail, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.getShifts();
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        checkForShiftInURL: async function() {
            console.log(this.shiftDetailByURL);
            await axios
                .get('shift-header/by-shift-detail/' + this.shiftDetailByURL, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    let shiftIdByURL = response.data;
                    console.log(shiftIdByURL);
                    let index = this.shift_headers.findIndex(
                        sh => sh.ShiftId == shiftIdByURL.ShiftId
                    );
                    this.header = this.shift_headers[index];
                    //this.scrollTo = true;
                    console.log(this.header);
                    this.getShifts();
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        chargeShift: function() {
            var date = moment().format('YYYY-MM-DD') + ' ' + 'PM';
            const index = this.shift_headers.findIndex(elm => {
                return elm.ShiftDate == date;
            });
            this.index = index;
            this.header = this.shift_headers[index];
            console.log(this.header);
            this.getShifts();
        },
        openMdAssingment() {
            this.parms.length = 0;
            this.$store.state.assignment.dialog = true;
            this.$store.state.assignment.new = true;
            var data = {
                header: this.header,
                drivers: this.drivers,
                trucks: this.trucks,
                trailers: this.trailers,
                yards: this.yards
            };
            this.parms.push(data);
            console.log(data);
        },
        openMdTruck() {
            this.$store.state.assignment.truckDisabled = true;
        },
        loadShiftHeaders: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('shift-header/dates-sa', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.shift_headers = response.data.data;
                    console.log(this.shift_headers);
                    if (this.shiftDetailByURL == '') {
                        this.chargeShift();
                    } else {
                        this.checkForShiftInURL();
                    }
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        loadDrivers: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('driver/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.drivers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },

        loadWithOutTrailers: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('shift-detail/without/trailer/' + this.header.ShiftId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.withoutTrailers = response.data;
                    this.withoutTrailersDlg = true;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        loadTrucks: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            if (this.trucks.length == 0) {
                axios
                    .get('truck/active', {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.trucks = response.data;
                        console.log(this.trucks);
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
            this.$store.state.isLoading = false;
        },
        changeTruck: function(item) {
            // this.$store.state.isLoading = true;
            var str = this.$store;
            var params = {
                Truck: item.Truck.TruckID
            };
            axios
                .put('shift-detail/' + item.ShiftDetail, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {})
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            // this.$store.state.isLoading = false;
        },
        changeDriver: function(item) {
            var str = this.$store;

            // str.state.isLoading = true;
            var params = {
                Driver: item.Driver.id,
                SentMailCounter: 0,
                PendingRevises: 0
            };
            axios
                .put('shift-detail/' + item.ShiftDetail, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save Successfull'
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        changeDriverTrainer: function(item) {
            var str = this.$store;

            // str.state.isLoading = true;
            var params = {
                DriverTrainer: item.DriverTrainer.id
            };
            axios
                .put('shift-detail/' + item.ShiftDetail, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save Successfull'
                    });
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        changeReplacementUnit: function(item) {
            // this.$store.state.isLoading = true;
            var str = this.$store;
            console.log(item);
            var params = {
                ReplacementUnit: item.ReplacementUnit
            };
            axios
                .put('shift-detail/' + item.ShiftDetail, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save Successfull'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            // this.$store.state.isLoading = false;
        },
        loadTrailers: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            if (this.trailers.length == 0) {
                axios
                    .get('trailer/active', {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.trailers = response.data.data;
                        console.log(this.trailers);
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
            this.$store.state.isLoading = false;
        },
        changeTrailer: function(item) {
            // this.$store.state.isLoading = true;
            var str = this.$store;
            var params = {
                Trailer: item.Trailer.id
            };
            axios
                .put('shift-detail/' + item.ShiftDetail, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save Successfull'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            // this.$store.state.isLoading = false;
        },
        loadYards: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            if (this.yards.length == 0) {
                axios
                    .get('yard/active', {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.yards = response.data.data;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
            this.$store.state.isLoading = false;
        },
        changeYard: function(item) {
            // this.$store.state.isLoading = true;
            var str = this.$store;
            var params = {
                TruckYard: item.Yard.id
            };
            axios
                .put('shift-detail/' + item.ShiftDetail, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save Successfull'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            // this.$store.state.isLoading = false;
        },
        countOrdersShifts: function(itm, open) {
            var str = this.$store;
            axios
                .get('/order/shift/' + itm.ShiftDetail, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const count = response.data;
                    if (count.length > 0) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'This ShiftDetail has ' +
                                count.length +
                                ' orders. It can not be deleted!!'
                        });
                    } else {
                        this.book = itm;
                        if (open) {
                            this.benchDialog = true;
                        } else {
                            this.$store.state.book.dialog = true;
                        }
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        changeStartTime: function(item) {
            // this.$store.state.isLoading = true;
            var str = this.$store;
            var params = {
                ShiftStartTime: item.ShiftStartTime
            };
            axios
                .put('shift-detail/' + item.ShiftDetail, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save Successfull'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            // this.$store.state.isLoading = false;
        },
        changeTargetHours: function(item) {
            // this.$store.state.isLoading = true;
            var str = this.$store;
            var params = {
                TargetHours: item.TargetHours
            };
            axios
                .put('shift-detail/' + item.ShiftDetail, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save Successfull'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            // this.$store.state.isLoading = false;
        },
        loadShifts: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('shift-detail/shift/' + this.header.ShiftId, {
                    //.get('shift-detail/create/shifts/by/drivers/' + this.header.ShiftId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.dataLoading = false;
                    this.shifts = response.data;
                    console.log(this.shifts);
                    this.getComment();
                    this.search = this.shiftDetailByURL;
                    /*if (this.scrollTo) {
                        console.log(this.shiftDetailByURL);
                        let element = document.getElementById(this.shiftDetailByURL);
                        console.log(element);
                        if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                        }
                    }*/
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        getShifts: function() {
            if (this.header.ShiftId == null) {
                this.dataLoading = false;
            } else {
                // this.loadWithOutTrailers();
                console.log(this.url);
                this.prints = true;
                this.dataLoading = true;
                this.loadShifts(this.header.ShiftId);
                this.url =
                    'http://upt.net:8000/api/shift-header/shift-report/' +
                    this.header.ShiftId;
            }
        },
        getComment: function() {
            var str = this.$store;
            axios
                .get('shift-header/' + this.header.ShiftId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.comment = response.data;
                    console.log(response.data);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        editComment: function() {
            var str = this.$store;
            axios
                .put('shift-header/' + this.comment.ShiftId, this.comment, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'comment saved successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        deleteItem: function(item, open) {
            var str = this.$store;
            if (item.Finalize == 1) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'This ShiftDetail finalized. It can not be deleted!!'
                });
            } else {
                this.countOrdersShifts(item, open);
            }
        },
        deleteShift: function(index) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .delete('shift-detail/' + index, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.loadShifts(this.header.ShiftId);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        addDriverShift: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            if (this.driver && this.header.ShiftId) {
                this.dataLoading = true;
                axios
                    .post(
                        'shift-detail/copy/driver/' +
                            this.driver.id +
                            '/' +
                            this.header.ShiftId,
                        '',
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    )
                    // eslint-disable-next-line no-unused-vars
                    .then(response => {
                        this.loadShifts(this.header.ShiftId);
                        this.driver = null;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
            this.$store.state.isLoading = false;
        },
        cloneShift: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            this.dataLoading = true;
            if (this.header == null || this.clone_header == null) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Requires a shift to be selected!'
                });
                this.dataLoading = false;
            } else {
                axios
                    .post(
                        'shift-detail/copy/header/' +
                            this.clone_header.ShiftId +
                            '/' +
                            this.header.ShiftId,
                        '',
                        {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        }
                    )
                    // eslint-disable-next-line no-unused-vars
                    .then(response => {
                        this.loadShifts(this.header.ShiftId);
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
            this.$store.state.isLoading = false;
        },

        printShiftAssignments: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get(
                    'shift-header/shift-report/' + this.header.ShiftId + '/0',
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'ShiftAssignmentsReport.pdf');
                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },

        printExcelAssignment: async function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            console.log(this.header.ShiftId);
            axios
                .get('shift-header/shift-report/excel/' + this.header.ShiftId, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Shift-Header-Excel.xlsx');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        validate(i) {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                if (i == 0) {
                    this.printShiftAssignments(false);
                } else if (i == 2) {
                    this.printShiftAssignments(true);
                } else if (i == 3) {
                    this.printExcelAssignment();
                } else {
                    this.editComment();
                }
            }
        }
    }
};
</script>
